"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.facebookAdsSearchTargeting = exports.facebookAdsSearchTargetingResultSchema = exports.facebookAdsSearchTargetingArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.facebookAdsSearchTargetingArgsSchema = zod_1.z.object({
    searchType: zod_1.z
        .enum(['interests', 'behaviors', 'demographics', 'life_events', 'locales'])
        .describe('Type of targeting option to search. interests: search by keyword. behaviors: predefined behavior categories. demographics: family status, education, etc. life_events: engagement, birthday, etc. locales: language targeting.'),
    query: zod_1.z
        .string()
        .optional()
        .nullable()
        .describe('Search keyword for interests or to filter other categories. Required for interests search. Optional for other types to filter results.'),
    limit: zod_1.z
        .number()
        .optional()
        .nullable()
        .default(50)
        .describe('Maximum number of results to return (default: 50)'),
    locale: zod_1.z
        .string()
        .optional()
        .nullable()
        .default('en_US')
        .describe('Locale for localized results (e.g., en_US, es_ES, fr_FR)'),
    emitMode: zod_1.z.literal('single'),
});
var targetingOptionSchema = zod_1.z
    .object({
    id: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]).optional(),
    key: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]).optional(),
    name: zod_1.z
        .union([zod_1.z.string(), zod_1.z.number()])
        .transform(function (v) { return String(v); })
        .describe('Human-readable name of the targeting option'),
    description: zod_1.z.string().optional().nullable().describe('Description of the targeting option'),
    path: zod_1.z
        .array(zod_1.z.string())
        .optional()
        .nullable()
        .describe('Category hierarchy path (e.g., ["Sports", "Tennis"])'),
    audience_size_lower_bound: zod_1.z
        .number()
        .optional()
        .nullable()
        .describe('Lower bound estimate of audience size'),
    audience_size_upper_bound: zod_1.z
        .number()
        .optional()
        .nullable()
        .describe('Upper bound estimate of audience size'),
    type: zod_1.z
        .string()
        .optional()
        .nullable()
        .describe('Category type (interests, behaviors, demographics, etc.)'),
})
    .passthrough()
    .transform(function (obj) { return (__assign(__assign({}, obj), { id: obj.id != null ? String(obj.id) : obj.key != null ? String(obj.key) : '' })); });
var facebookAdsSearchTargetingResultShape = zod_1.z.object({
    targetingOptions: zod_1.z
        .array(targetingOptionSchema)
        .default([])
        .describe('List of targeting options matching the search criteria'),
    searchType: zod_1.z
        .union([zod_1.z.string(), zod_1.z.number()])
        .transform(function (v) { return String(v); })
        .describe('The type of targeting search performed'),
    totalResults: zod_1.z
        .union([zod_1.z.number(), zod_1.z.string()])
        .transform(function (v) { return (typeof v === 'string' ? parseInt(v, 10) : v); })
        .describe('Total number of results returned'),
});
exports.facebookAdsSearchTargetingResultSchema = zod_1.z.preprocess(function (val) {
    if (val && typeof val === 'object' && 'result' in val && val.result != null) {
        return val.result;
    }
    if (val && typeof val === 'object' && 'data' in val && val.data != null) {
        return val.data;
    }
    return val;
}, facebookAdsSearchTargetingResultShape);
exports.facebookAdsSearchTargeting = (0, common_1.createToolMetadata)({
    id: 'facebookAdsSearchTargeting',
    displayName: 'Search Meta Ad Targeting Options',
    displayDescription: 'Search for detailed targeting options like interests, behaviors, demographics, and life events',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.facebookAdsSearchTargetingArgsSchema,
}, exports.facebookAdsSearchTargetingResultSchema);
